import React, {useState, useEffect, useRef, Fragment} from 'react'
import {TextField,  Button,Divider, Container, Grid, Typography, InputAdornment, Table, TableHead, TableBody, TableCell
, TableRow} from '@material-ui/core'
import EmailIcon from '@material-ui/icons/Email';
import LockIcon from '@material-ui/icons/Lock';
import Conexao from '../../providers/Conexao'
import ConexaoB from '../../providers/ConexaoB'
import Swal from 'sweetalert2'
import {withRouter} from 'react-router-dom'
import Principal from '../Principal/Principal'
import {Breadcrumbs} from '@material-ui/core'
import {Link } from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress';
import ModalFull from '../../components/ModalFull'

import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import BuildTwoToneIcon from '@material-ui/icons/BuildTwoTone';
import SettingsIcon from '@material-ui/icons/Settings';

import Tooltip from '@material-ui/core/Tooltip';

import LockOpenIcon from '@material-ui/icons/LockOpen';
import EditIcon from '@material-ui/icons/Edit';
import FormNovoFuncionario from './FormNovoFuncionario'
import TablePagination from '@material-ui/core/TablePagination';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import DisplayStatus from '../../components/DisplayStatus'



const CadastroFuncionarios = (props)=>{
    const classes = useStyles();
    const [openModal, setOpenModal]= useState(false)
    const [loading, setLoading] = useState(false)
    const [funcionarios, setFuncionarios] = useState([])
    const [empresa, setEmpresa] = useState([])
    const [edicao, setEdicao] = useState([])
    const [parametroFiltro, setParametroFiltro] = useState([])
    const [filtro, setFiltro] = useState([])
    const [dataTecnico, setDataTecnico] = useState([])
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [page, setPage] = React.useState(2);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };



    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(()=>{
        getFuncionarios();
    }, [])

    useEffect(()=>{
        if(!openModal){
            setEdicao([])
        }
    }, [openModal])


    const getFuncionarios = () =>{
        
        setLoading(true)
        Conexao.post('funcionariosController/getfuncionarios?idusuario='+props.location.state.empresa.idrevenda, {
            filtro : filtro, tipoFiltro : parametroFiltro
        }).then(response =>{
            
            if(response.status == 200){
               
                if(response.data.status == 'OK'){
                    setFuncionarios(response.data.payload);
                    console.log(response.data.payload)
                }else{
                    setFuncionarios([])
                }
            }else{
                setFuncionarios([])
            }
            setLoading(false)
        }).catch(error =>{
            setLoading(false)
        })
    }

    const verificaEmpresaAtiva = (id, operacao) =>{
        
       return true;
    }

    

    


    return <Principal atualizar = {loading}>
     <Grid container spacing = {2}>
            <Grid item xs = {7}><Typography>Cadastro de Funcionários</Typography></Grid>
            <Grid item xs = {5}>
            <TablePagination
                component="div"
                count={0}
                page={page}
                onChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Grid>
        </Grid>
        <Grid container spacing = {2}>
            <Grid item xs = {2}>
                <TextField
                    label ='Status'
                    variant ='outlined'
                    fullWidth
                    InputLabelProps={{shrink : true}}
                    select
                    SelectProps={{native : true}}                  
                    >
                    <option>ATIVO</option>
                    <option>INATIVO</option>
                    <option>TODOS</option>
                    
                    </TextField>
            </Grid>
            <Grid item xs = {2}>
                <TextField
                    label ='CPF'
                    variant ='outlined'
                    fullWidth
                    InputLabelProps={{shrink : true}}                              
                   />
            </Grid>
            <Grid item xs = {6}>
                <TextField
                    label ='Nome'
                    variant ='outlined'
                    fullWidth
                    InputLabelProps={{shrink : true}}  
                              
                   />
            </Grid>

            <Grid item xs = {2} spacing={2} className='container-buttons'>
                <Button color = 'primary' variant='contained' onClick={()=>getFuncionarios()}><SearchIcon/> Pesquisar</Button>
                <Button color='secondary' variant='contained' ><ClearIcon/> Limpar</Button>
            </Grid>
        </Grid>
        <br/>
        <div>
            <Breadcrumbs aria-label="breadcrumb">            
                <Link color="inherit" to={"/home/revenda/"+props.match.params.idempresa} >
                    Home
                </Link>
            <Typography color="textPrimary">Funcionários</Typography>
            </Breadcrumbs>
        </div> 
    
   
    <div className='div-form-container'>
    <Grid container style = {{marginTop:"10px"}} spacing={1}>
        <Table  className='table table-bordered table-striped table-hover table-sm'>
            <TableHead>
                <TableCell align='center'>CPF</TableCell>
                <TableCell>Nome Completo</TableCell>
                <TableCell align='center'>Cidade</TableCell>
                <TableCell align='center'>Estado</TableCell>
                <TableCell align='center'>Editar</TableCell>
                <TableCell align='center'>Status</TableCell>
            </TableHead>
            <TableBody>
                {
                    funcionarios && funcionarios.map(function(funcionario, i){
                        return <TableRow id = {'EMP'+i}>
                                   
                                    <TableCell align='center'><Typography variant='caption' color='primary'>{funcionario.cpf_cnpj}</Typography></TableCell>
                                    <TableCell>
                                        <Typography variant='subtitle2' color='primary'>{funcionario.nomecompleto}</Typography>
                                        </TableCell>
                                    <TableCell align='center'><Typography variant='caption' color='primary'>{funcionario.cidade}</Typography></TableCell>
                                    <TableCell align='center'><Typography variant='caption' color='primary'>{funcionario.estado}</Typography></TableCell>
                                    <TableCell align='center'>
                                        <Tooltip title ='Editar informações da funcionario'>
                                            <Button onClick = {()=>{
                                                setEdicao(funcionario)
                                                setOpenModal(true)
                                                handleClose();
                                            }}><BuildTwoToneIcon color='primary'/></Button>
                                        </Tooltip>  
                                    </TableCell>
                                    <TableCell align='center'>

                                      <DisplayStatus ativo ={funcionario.ativo} onclick={()=>{
                                             Swal.fire({
                                                icon : 'info',
                                                text :'Deseja Realmente realizar operação  ?',                  
                                                showCancelButton: true,
                                                confirmButtonText: 'Confirmar',
                                                cancelButtonText : 'Cancelar', 
                                                allowOutsideClick: () => !Swal.isLoading()
                                                }).then((result) => {
                                                if (result.isConfirmed) {
                                                    
                                                    Conexao.get('funcionariosController/changeStatus?idFuncionario='+funcionario.idtecnico+'&status='+funcionario.ativo).then(response =>{
                                                        if(response.data.status == 'OK'){                                                        
                                                            getFuncionarios()                                                         
                                                                
                                                            //setFuncionarios(funcionarios.filter(item => item.idempresa != empresa.idempresa ))
                                                            Swal.fire({
                                                                text:'Operação realizada com sucesso !', 
                                                                icon :'success', 
                                                                timer : 1500, 
                                                                showCancelButton:false, 
                                                                showConfirmButton:false
                                                            })
                                                            }
                                                            
                                                           
                                                       
                                                    }).catch(error =>{

                                                    })
                                                }
                                                })

                                        
                                        }}/>                                           
                                    </TableCell>
                                </TableRow>
                    })
                }
                {
                       funcionarios.length == 0  && <TableRow>
                       <TableCell colSpan={6} align='left'>* Não existe(m) registro(s)</TableCell>
                      
                   </TableRow>
                   }
            </TableBody>
        </Table>
    </Grid>
    </div>
    <ModalFull fixedSize={false} size='md' titulo = {edicao.idempresa ? 'Edição do Técnico : '+edicao.nomecompleto :'Cadastro de Novo Técnico'} showModal = {openModal} closeModal= {()=>setOpenModal(false)}>
        <FormNovoFuncionario
                closeModal= {()=>setOpenModal(false)}
                updateFuncionarios = {()=>getFuncionarios()}
                edicaoFuncionario = {edicao}
            />
        
    </ModalFull>

    <div className='fabIncluir'>
        <Fab size="large" color="primary" aria-label="add" onClick={()=>setOpenModal(true)} >
          <AddIcon />
        </Fab>
    </div>
    </Principal>
}

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
  }));

export default withRouter(CadastroFuncionarios)